<template>
  <modal class="message-modal" title="新建管理员" :accept="onAccept">
    <vx-form class="w-full" layout="v" label-align="center">
      <form-item required label="用户" >
        <vs-input class="w-full" placeholder="请输入用户名" v-model="uid" />
      </form-item>
      <form-item required label="角色" >
        <v-select
              :options="roles"
              v-model="roleID"
              :reduce="p => p.id"
              label="name"
            ></v-select>
      </form-item>
    </vx-form>
    
  </modal>
</template>
<script>
export default {
  inheritAttrs: false,
  data() {
    return {
      uid: '',
      roleID: '',
    }
  },
  props: {
    onOk: Function
  },
  $computed: ['user.roles'],
  methods: {
    async onAccept() {
      const data = {
        roleID: this.roleID,
        uid: Number(this.uid),
      }
      await this.$s.user.createAdmin(data)
      this.$notify({
        title: '成功新增管理员',
      })
      this.onOk(data)
    }
  }

}
</script>